import { render, staticRenderFns } from "./ButtonMore.vue?vue&type=template&id=7a70e288&scoped=true&"
import script from "./ButtonMore.vue?vue&type=script&lang=js&"
export * from "./ButtonMore.vue?vue&type=script&lang=js&"
import style0 from "./ButtonMore.vue?vue&type=style&index=0&id=7a70e288&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a70e288",
  null
  
)

export default component.exports